<template>
  <j-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <a-table
      ref="table"
      size="middle"
      bordered
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      class="j-table-force-nowrap"
      @change="handleTableChange">

        <span slot="auditStatusName" slot-scope="text, record" >
          <a v-if="record.relationId != null" @click="unBind(record.appid)">{{language['system.relieveBind']}}</a>
          <!--<a-span v-if-else="record.relationId == null&&r.auditStatus == 'approving'">
            绑定审核中
          </a-span>
          <a v-else>绑定</a>-->
          <div v-else>
            <div v-if="record.auditStatus == 'approving'">{{language['system.bind']}}{{language['user.apply.under.review']}}</div>
<!--            <a v-else-if="record.auditStatus == 'approved'" @click="unBind(record.appid)">{{language['system.relieveBind']}}</a>-->
            <a v-else @click="appAuthorize(record.appid)">{{language['system.bind']}}</a>
          </div>
        </span>
       <!-- <span slot="action" slot-scope="text, record" v-if="(record.auditStatus==null||record.auditStatus=='rejected'||record.auditStatus=='approved')&&record.relationId==null">
           <a-popconfirm :title="language['user.apply.cofing']" @confirm="() => appAuthorize(record.appid)">
             <a>{{ language['user.apply.authorize'] }}</a>
           </a-popconfirm>
        </span>-->

    </a-table>

  </j-modal>
</template>

<script>
  import {httpAction, getAction} from '@/api/manage'
    export default {
      name: "UserApplicationModel",
      data() {
        return {
          description: '',
          url: {
            list: "/sys/sysUserApplicationApply/alllist",
            myAppList: "/sys/sysUserApplicationApply/list/records",
            add: "/sys/sysUserApplicationApply/userBindApplication"
          },

          title:this.$store.getters.language['user.bindApplicationBtn'],
          width: 800,
          visible: false,
          disableSubmit: false,
          confirmLoading:false,
          queryParam: {},
          ipagination:{
            current: 1,
            pageSize: 10,
            showQuickJumper: false,
            showSizeChanger: false,
            total: 0
          },
          dataSource:[],
          model:{},
        }
      },
      computed: {
        language() {
          return this.$store.getters.language
        },
        columns() {
          if (this.language) {
            return [
              {
                title: '#',
                dataIndex: '',
                key: 'rowIndex',
                width: 60,
                align: "center",
                customRender: function (t, r, index) {
                  return parseInt(index) + 1;
                }
              },
              {
                title: this.language['user.apply.system.name'],
                align: "center",
                dataIndex: 'applicationName',
                width: 180
              },
              {
                title: this.language['user.apply.description'],
                align: "center",
                dataIndex: 'applicationDesc',
                width: 180
              },
              {
                title: this.language['user.apply.or.authorize'],
                align: "center",
                dataIndex: 'auditStatusName',
                width: 147,
                scopedSlots: {customRender: 'auditStatusName'},
                /*customRender: function (t, r, index) {
                  console.log("r=========", r);
                  //审核中为未处理状态，其它的审核状态就以为是否绑定应用为准
                  if (r.relationId != null) {
                    return "已绑定";
                  } else {
                    if (r.auditStatus == 'approving') {
                      return t;
                    } else {
                      return "未授权";
                    }
                  }
                }*/
              },
              /*{
                title: this.language['common.action'],
                align: "center",
                dataIndex: 'action',
                width: 180,
                scopedSlots: {customRender: 'action'}
              }*/
            ]
          }
        },
      },
      methods:{
        edit (record) {
          this.visible = true
          /*this.ipagination.current = 1;
          this.ipagination.pageSize = 10;
          this.ipagination.total = 0;*/
            this.model = record;
          this.queryHttp(this.url.list, this.ipagination,record);
        },
        handleTableChange(pagination, filters, sorter) {
          this.ipagination = pagination;
          this.queryHttp(this.url.list, this.ipagination,this.model);
        },
        queryHttp(url, ipaginationObj,user) {
          this.queryParam.pageNo = ipaginationObj.current;
          this.queryParam.pageSize = ipaginationObj.pageSize;
          this.queryParam.userId = user.id;
          getAction(url, this.queryParam).then((res) => {
            if (res.success) {
              this.dataSource = res.result.records;
              ipaginationObj.current = res.result.current;
              ipaginationObj.total = Number(res.result.total);
              ipaginationObj.pages = res.result.pages;
            }
          })
        },
        appAuthorize(appid) {
          let param = {
            "applicationId": appid,
            "userId": this.model.id
          };
          httpAction(this.url.add, param, "post").then((res) => {
            if (res.success) {
              this.$message.success("绑定成功!");
              this.queryHttp(this.url.list, this.ipagination,this.model);
            } else {
              this.$message.error("绑定失败!");
            }
          }).finally(() => {
          })
        },
        unBind(appid){
          let param = {
            "applicationId": appid,
            "userId": this.model.id
          };
          httpAction("/sys/sysUserApplicationApply/userUnBindApplication", param, "post").then((res) => {
            if (res.success) {
              this.$message.success("解绑成功!");
              this.queryHttp(this.url.list, this.ipagination,this.model);
            } else {
              this.$message.error("解绑失败!");
            }
          }).finally(() => {
          })
        },
        handleOk() {
          // this.$refs.realForm.submitForm();
          // this.tocancel()
          this.close()
        },
        handleCancel() {
          this.close()
        },
        close() {
          this.ipagination={
            current: 1,
              pageSize: 10,
              showQuickJumper: false,
              showSizeChanger: false,
              total: 0
          }
          this.$emit('ok');
          this.visible = false;
        },
      }
    }
</script>

<style scoped>

</style>